import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ApiVisa} from '../../shared/api-visa.model';

@Injectable({
  providedIn: 'root'
})
export class ShopeeShipOrderService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/logistic/ship-order';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/logistic/ship-order';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/logistic/ship-order';
    this.httpClient = http;
  }

  shipOrder(branchGuid: string, package_number: string, order_sn: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?' + 'branch_guid=' + branchGuid + '&' + 'package_number=' + package_number + '&' + 'order_sn=' + order_sn;
    return this.httpClient.post(url, null, this.getHttpHeader(apiVisa));
  }

  shipOrderWithType(branchGuid: string, package_number: string, order_sn: string, type: string, dtoObject: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?' + 'branch_guid=' + branchGuid + '&' + 'package_number=' + package_number + '&' + 'order_sn=' + order_sn + '&' + 'shipping_type=' + type;
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(apiVisa));
  }

  shipOrderUnsplitOrder(branchGuid: string, order_sn: string, type: string, dtoObject: any, apiVisa: ApiVisa, address_id: number = null, pickup_time_id: string = null, tracking_number: string = null) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }

    // Adding Parameters for the Shopee Pickup
    let shopeeParams = ''
    if(address_id) shopeeParams += `&address_id=${address_id}`
    if(pickup_time_id) shopeeParams += `&pickup_time_id=${pickup_time_id}`
    if(tracking_number) shopeeParams += `&tracking_number=${tracking_number}`

    const url = this.apiUrl + '?' + 'branch_guid=' + branchGuid + '&' + 'order_sn=' + order_sn + '&' + 'shipping_type=' + type + shopeeParams;
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(apiVisa));
  }
}
